module.exports = [
	'image',
	'icon',
	'video',
	'animation'
]
